import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyPagination;

export const DsyPagination = createComponent(
  React,
  'dsy-pagination',
  LitComp,
  {},
);

export default DsyPagination;
